module.exports = __webpack_public_path__ + "static/media/logo_light.4ac2a567.png";